import { render, staticRenderFns } from "./CompaniesDashboard.vue?vue&type=template&id=44f0bd14&"
import script from "./CompaniesDashboard.vue?vue&type=script&lang=js&"
export * from "./CompaniesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports